import {useState, useEffect, FC} from "react";

export const ProgressBar: FC<{percentage: number}> = ({percentage}) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    // Animar la barra al cargar
    const timeout = setTimeout(() => setWidth(percentage), 100); // pequeño delay
    return () => clearTimeout(timeout);
  }, [percentage]);

  return (
    <div className="w-5/6 mx-auto mt-12 flex flex-col items-center">
      {/* Texto centrado */}
      <span className="mb-2 text-md font-semibold text-gray-700 dark:text-gray-200">
        Números vendidos: {width.toFixed(2)}%
      </span>

      {/* Contenedor de la barra */}
      <div className="w-full bg-neutral-50 dark:bg-neutral-700 rounded-3xl h-10 shadow-inner overflow-hidden">
        {/* Barra de progreso */}
        <div
          className="h-10 flex items-center justify-center text-black font-bold rounded-3xl shadow-xl transition-all duration-1000 ease-out
                 bg-gradient-to-r from-primary-300 to-primary-500 dark:from-primary-300 dark:to-primary-500"
          style={{
            width: `${width}%`,
          }}
        ></div>
      </div>
    </div>
  );
};
